var render = function render(_c,_vm){return _c('main',[_c('b-container',[_c('b-row',[_c('b-col',[_c('p',{staticClass:"main-title text-center"},[_vm._v("\n          Az oldal nem található!\n        ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }